import { combineReducers } from "redux";
import { PMSUserStore } from "./_stores/PMSUserStore";
import { CommonStore } from "../Everou/_reducers/common.reducer";
import { PMSLocationsSelector, locations } from "./_reducers/locations.reducer";
import { PMSLocationsSecondaryViewStore } from "./_stores/PMSLocationsSecondaryViewStore";
import { PMSLocationDetailModeSelectors } from "./_selectors/PMSLocationDetailModeSelectors";
import { viewMode } from "./_reducers/viewMode.reducer";
import { PMSLocationLogsCollection } from "./_stores/PMSLocationLogsCollection";
import { PMSLocationLogsDateFilter } from "./_stores/PMSLocationLogsDateFilter";
import { PMSLocationProtectLogsCollection } from "./_stores/PMSLocationProtectLogsCollection";
import { PMSLocationProtectLogsDateFilter } from "./_stores/PMSLocationProtectLogsDateFilter";
import { PMSLocationReservationsCollection } from "./_stores/PMSLocationReservationsCollection";
import { PMSIntegrationsCollection } from "./_stores/PMSIntegrationsCollection";
import { PMSLocationIntegrationsCollection } from "./_stores/PMSLocationIntegrationsCollection";
import { PMSKrossBookingStore } from "./_stores/PMSKrossBookingStore";
import { PMSLocationGroupsCollection } from "./_stores/PMSLocationGroupsCollection";
import { PMSLocationRoomsCollection } from "./_stores/PMSLocationRoomsCollection";
import { PMSHostifyStore } from "./_stores/PMSHostifyStore";
import { PMSSmoobuStore } from "./_stores/PMSSmoobuStore";
import { PMSOctorateStore } from "./_stores/PMSOctorateStore";
import { PMSCustomizationTemplateStore } from "./_stores/PMSCustomizationTemplateStore";
import { PMSOrganizationCustomizationTemplateStore } from "./_stores/PMSOrganizationCustomizationTemplateStore";
import { PMSActiveOrganizationStore } from "./_stores/PMSActiveOrganizationStore";
import { PMSOrganizationTabStore } from "./_stores/PMSOrganizationTabStore";
import { PMSScopeOverrideStore } from "./_stores/PMSScopeOverrideStore";
import { PMSFocusedTemplateStore } from "./_stores/PMSFocusedTemplateStore";
import { PMSAccountDraftStore } from "./_stores/PMSAccountDraftStore";
import { PMSChatSelector, chats } from "./_reducers/chat.reducer";
import { PMSChatMessagesCollection } from "./_stores/PMSChatMessagesCollection";
import { PMSTagsCollection } from "./_stores/PMSTagsCollection";
import {
    PMSIntegrationsSelector,
    pmsIntegrations,
} from "./_reducers/integrations.reducer";
import { PMSAvaibookStore } from "./_stores/PMSAvaibookStore";
import { PMSLodgifyStore } from "./_stores/PMSLodgifyStore";
import { PMSGuestyStore } from "./_stores/PMSGuestyStore";
import { PMSAvantioStore } from "./_stores/PMSAvantioStore";
import {
    OrganizationsSelector,
    organizations,
} from "../Organizations/_reducers/organizations.reducer";

// ROOT STATE
let getRootState = (state) => state;

function setRootStateFn(getRootStateFn = (state) => state) {
    getRootState = getRootStateFn;
}

// REDUCER
const reducer = combineReducers({
    pmsUser: PMSUserStore.reducer,
    locations,
    tags: PMSTagsCollection.reducerCollection,
    chats,
    viewMode,
    secondaryViews: combineReducers({
        locations: PMSLocationsSecondaryViewStore.reducer,
    }),
    locationLogs: combineReducers({
        logs: PMSLocationLogsCollection.reducerCollection,
        dateFilter: PMSLocationLogsDateFilter.reducer,
    }),
    locationProtectLogs: combineReducers({
        logs: PMSLocationProtectLogsCollection.reducerCollection,
        dateFilter: PMSLocationProtectLogsDateFilter.reducer,
    }),
    locationReservations: combineReducers({
        reservations: PMSLocationReservationsCollection.reducerCollection,
    }),
    integrations: PMSIntegrationsCollection.reducerCollection,
    locationIntegrations: PMSLocationIntegrationsCollection.reducerCollection,
    krossBooking: PMSKrossBookingStore.reducerCollection,
    locationGroups: PMSLocationGroupsCollection.reducerCollection,
    locationRooms: PMSLocationRoomsCollection.reducerCollection,
    hostify: PMSHostifyStore.reducerCollection,
    smoobu: PMSSmoobuStore.reducerCollection,
    octorate: PMSOctorateStore.reducerCollection,
    avaibook: PMSAvaibookStore.reducerCollection,
    lodgify: PMSLodgifyStore.reducerCollection,
    guesty: PMSGuestyStore.reducerCollection,
    avantio: PMSAvantioStore.reducerCollection,
    customizationTemplate: PMSCustomizationTemplateStore.reducer,
    organizationCustomizationTemplate:
        PMSOrganizationCustomizationTemplateStore.reducer,
    activeOrganization: PMSActiveOrganizationStore.reducer,
    organizationTab: PMSOrganizationTabStore.reducer,
    scopeOverride: PMSScopeOverrideStore.reducer,
    focusedTemplate: PMSFocusedTemplateStore.reducer,
    accountDraft: PMSAccountDraftStore.reducer,
    chatMessages: combineReducers({
        messages: PMSChatMessagesCollection.reducerCollection,
    }),
    pmsIntegrations,
    organizations,
});

// SELECTORS
PMSUserStore.setRootStateFn((state) => getRootState(state).pmsUser);
PMSLocationsSelector.setRootStateFn((state) => getRootState(state).locations);
PMSLocationDetailModeSelectors.setRootState(
    (state) => getRootState(state).viewMode,
);
const getSecondaryViewState = (state) => getRootState(state).secondaryViews;
PMSLocationsSecondaryViewStore.setRootStateFn(
    (state) => getSecondaryViewState(state).locations,
);
PMSKrossBookingStore.setRootStateFn(
    (state) => getRootState(state).krossBooking,
);
PMSHostifyStore.setRootStateFn((state) => getRootState(state).hostify);
PMSSmoobuStore.setRootStateFn((state) => getRootState(state).smoobu);
PMSOctorateStore.setRootStateFn((state) => getRootState(state).octorate);
PMSAvaibookStore.setRootStateFn((state) => getRootState(state).avaibook);
PMSLodgifyStore.setRootStateFn((state) => getRootState(state).lodgify);
PMSGuestyStore.setRootStateFn((state) => getRootState(state).guesty);
PMSAvantioStore.setRootStateFn((state) => getRootState(state).avantio);
PMSCustomizationTemplateStore.setRootStateFn(
    (state) => getRootState(state).customizationTemplate,
);
PMSOrganizationCustomizationTemplateStore.setRootStateFn(
    (state) => getRootState(state).organizationCustomizationTemplate,
);
PMSActiveOrganizationStore.setRootStateFn(
    (state) => getRootState(state).activeOrganization,
);
PMSOrganizationTabStore.setRootStateFn(
    (state) => getRootState(state).organizationTab,
);
PMSScopeOverrideStore.setRootStateFn(
    (state) => getRootState(state).scopeOverride,
);
PMSFocusedTemplateStore.setRootStateFn(
    (state) => getRootState(state).focusedTemplate,
);
PMSAccountDraftStore.setRootStateFn(
    (state) => getRootState(state).accountDraft,
);
PMSChatSelector.setRootStateFn((state) => getRootState(state).chats);
PMSIntegrationsSelector.setRootStateFn(
    (state) => getRootState(state).pmsIntegrations,
);
OrganizationsSelector.setRootStateFn(
    (state) => getRootState(state).organizations,
);

let panelMemo: { integrations: any[]; uid: string | null; result: any[] } | null = null;
function integrationsInPanel(integrations: any[], uid: string | null) {
    if (panelMemo && panelMemo.integrations === integrations && panelMemo.uid === uid) {
        return panelMemo.result;
    }
    const focused = uid ? integrations.filter((integration) => integration.uid === uid) : [];
    const result = focused.length > 0 ? focused : integrations;
    panelMemo = { integrations, uid, result };
    return result;
}

const selectors = {
    getPMSUser: PMSUserStore.selectorGet,
    tagsState: (state) => getRootState(state).tags,
    getTags: (state) =>
        PMSTagsCollection.selectorGetItems(selectors.tagsState(state)),
    getPMSLocations: PMSLocationsSelector.getPMSLocations,
    getPMSLocationsFilter: PMSLocationsSelector.getPMSLocationsFilter,
    getPMSLocationSelectedUid: PMSLocationsSelector.getPMSLocationSelectedUid,
    getPMSLocationSelectedName: PMSLocationsSelector.getPMSLocationSelectedName,
    getPMSLocationSelectedOrganizationName:
        PMSLocationsSelector.getPMSLocationSelectedOrganizationName,
    getPMSLocationSelectedOrganizationUid:
        PMSLocationsSelector.getPMSLocationSelectedOrganizationUid,
    getPMSLocationSelectedTimezone:
        PMSLocationsSelector.getPMSLocationSelectedTimezone,
    getPMSLocationSelectedHasIntegration:
        PMSLocationsSelector.getPMSLocationSelectedHasIntegration,
    getPMSLocationSelectedHasIntegrationError:
        PMSLocationsSelector.getPMSLocationSelectedHasIntegrationError,
    getPMSLocationSelectedVacationRentalPlan:
        PMSLocationsSelector.getPMSLocationSelectedVacationRentalPlan,
    getPMSLocationSelectedPendingEarlyCheckinCount:
        PMSLocationsSelector.getPMSLocationSelectedPendingEarlyCheckinCount,
    getPMSLocationSelectedPermissionType:
        PMSLocationsSelector.getPMSLocationSelectedPermissionType,
    getPMSLocationDevices: PMSLocationsSelector.getPMSLocationDevices,
    getPMSLocationRooms: PMSLocationsSelector.getPMSLocationRooms,
    getPMSLocationsSecondaryView: PMSLocationsSecondaryViewStore.selectorGet,
    getPMSLocationDetailViewMode:
        PMSLocationDetailModeSelectors.getPMSLocationDetailViewMode,
    locationLogsRootState: (state) => getRootState(state).locationLogs,
    locationLogsState: (state) => selectors.locationLogsRootState(state).logs,
    getPMSLocationLogsNextPage: (state) =>
        PMSLocationLogsCollection.selectorGetNextPage(
            selectors.locationLogsState(state),
        ),
    getPMSLocationLogsDateFilter: (state) =>
        PMSLocationLogsDateFilter.selectorGetBeginEnd(
            selectors.locationLogsRootState(state).dateFilter,
        ),
    getPMSLocationLogsIsRequesting: (state) =>
        PMSLocationLogsCollection.selectorIsRequestingList(
            selectors.locationLogsState(state),
        ),
    getPMSLocationLogsIsRequestingFirst: (state) =>
        PMSLocationLogsCollection.selectorIsRequestingFirstPage(
            selectors.locationLogsState(state),
        ),
    getPMSLocationLogs: (state) =>
        PMSLocationLogsCollection.selectorGetItems(
            selectors.locationLogsState(state),
        ),
    locationProtectLogsRootState: (state) =>
        getRootState(state).locationProtectLogs,
    locationProtectLogsState: (state) =>
        selectors.locationProtectLogsRootState(state).logs,
    getPMSLocationProtectLogsNextPage: (state) =>
        PMSLocationProtectLogsCollection.selectorGetNextPage(
            selectors.locationProtectLogsState(state),
        ),
    getPMSLocationProtectLogsDateFilter: (state) =>
        PMSLocationProtectLogsDateFilter.selectorGetBeginEnd(
            selectors.locationProtectLogsRootState(state).dateFilter,
        ),
    getPMSLocationProtectLogsIsRequesting: (state) =>
        PMSLocationProtectLogsCollection.selectorIsRequestingList(
            selectors.locationProtectLogsState(state),
        ),
    getPMSLocationProtectLogsIsRequestingFirst: (state) =>
        PMSLocationProtectLogsCollection.selectorIsRequestingFirstPage(
            selectors.locationProtectLogsState(state),
        ),
    getPMSLocationProtectLogs: (state) =>
        PMSLocationProtectLogsCollection.selectorGetItems(
            selectors.locationProtectLogsState(state),
        ),
    getPMSLocationInfo: PMSLocationsSelector.getPMSLocationInfo,
    locationReservationsRootState: (state) =>
        getRootState(state).locationReservations,
    locationReservationsState: (state) =>
        selectors.locationReservationsRootState(state).reservations,
    getPMSLocationReservations: (state) =>
        PMSLocationReservationsCollection.selectorGetItems(
            selectors.locationReservationsState(state),
        ),
    getPMSChatFilter: PMSChatSelector.getPMSChatFilter,
    getPMSChatIsRequesting: PMSChatSelector.getPMSChatIsRequesting,
    chatMessagesRootState: (state) => getRootState(state).chatMessages,
    chatMessagesState: (state) =>
        selectors.chatMessagesRootState(state).messages,
    getPMSChatMessages: (state) =>
        PMSChatMessagesCollection.selectorGetItems(
            selectors.chatMessagesState(state),
        ),
    integrationsState: (state) => getRootState(state).integrations,
    getPMSIntegrations: (state) =>
        PMSIntegrationsCollection.selectorGetItems(
            selectors.integrationsState(state),
        ),
    getPMSFocusedTemplate: (state) => PMSFocusedTemplateStore.selectorGet(state),
    getPMSAccountDraft: (state) => PMSAccountDraftStore.selectorGet(state),
    // What a company's panel lists: the whole catalog, or just the account
    // the screen was sent to (PMSFocusedTemplateStore) when the catalog holds
    // it. A focus on an account the catalog lacks (a colleague's personal
    // one) leaves the list whole: the module says why instead. Memoized on
    // its two inputs so the panels' effects on the list don't re-fire on
    // every unrelated store change.
    getPMSIntegrationsInPanel: (state) => {
        const integrations = selectors.getPMSIntegrations(state);
        const focused = selectors.getPMSFocusedTemplate(state);
        return integrationsInPanel(integrations, focused?.uid ?? null);
    },
    locationIntegrationsState: (state) =>
        getRootState(state).locationIntegrations,
    getPMSLocationIntegrations: (state) =>
        PMSLocationIntegrationsCollection.selectorGetItems(
            selectors.locationIntegrationsState(state),
        ),
    getPMSLocationCustomization:
        PMSLocationsSelector.getPMSLocationCustomization,
    getPMSLocationCustomizationUid:
        PMSLocationsSelector.getPMSLocationCustomizationUid,
    getPMSCustomizationIsUploading:
        PMSLocationsSelector.getPMSCustomizationIsUploading,
    getPMSLocationsIsRequesting:
        PMSLocationsSelector.getPMSLocationsIsRequesting,
    locationGroupsState: (state) => getRootState(state).locationGroups,
    getPMSLocationGroups: (state) =>
        PMSLocationGroupsCollection.selectorGetItems(
            selectors.locationGroupsState(state),
        ),
    getPMSReservationNewDraft: PMSLocationsSelector.getPMSReservationNewDraft,
    getPMSCustomizationTemplate: PMSCustomizationTemplateStore.selectorGet,
    getPMSCustomizationTemplateIsUploading:
        PMSCustomizationTemplateStore.selectorGetIsRequesting,
    getPMSOctorateUser: PMSIntegrationsSelector.getPMSOctorateUser,
    getOrganizations: OrganizationsSelector.getOrganizations,
    getOrganizationSelectedUid: OrganizationsSelector.getSelectedUid,
    getOrganizationSelectedDetail: OrganizationsSelector.getSelectedDetail,
    getOrganizationsIsRequesting: OrganizationsSelector.getIsRequesting,
    getOrganizationDetailIsRequesting:
        OrganizationsSelector.getIsRequestingDetail,
    getOrganizationAvailableLocations:
        OrganizationsSelector.getAvailableLocationsForSelected,
    getOrganizationAvailableLocationsTotal:
        OrganizationsSelector.getAvailableLocationsTotalForSelected,
    getOrganizationAvailableLocationsSearchTerm:
        OrganizationsSelector.getAvailableLocationsSearchTermForSelected,
    getOrganizationCustomizationTemplate:
        PMSOrganizationCustomizationTemplateStore.selectorGet,
    getOrganizationCustomizationIsUploading:
        PMSOrganizationCustomizationTemplateStore.selectorGetIsRequesting,
    getPMSActiveOrganizationChoice: PMSActiveOrganizationStore.selectorGet,
    getPMSOrganizationRequestedTab: PMSOrganizationTabStore.selectorGet,
    getOrganizationsHasLoaded: OrganizationsSelector.getHasLoaded,
    getOrganizationsHasFailed: OrganizationsSelector.getHasFailed,
    getOrganizationsIsRequestingList:
        OrganizationsSelector.getIsRequestingList,
    ...CommonStore.selectors,
};

// EXPORT
export const PMSStore = {
    setRootStateFn,
    reducer,
    selectors,
};
